<template>
    <PageWrapper layout="boxed">
        <div class="bg-gray-900 rounded border-gray-alt2 border max-w-2xl m-auto text-center">
            <template>
                <h1 class="p-8 dm-sans capitalize text-white text-2xl leading-none">Maintenance Mode</h1>
            </template>
        </div>
    </PageWrapper>
</template>
<script>
export default {
    name:"MaintenanceMode"
}
</script>